export default "__VITE_ASSET__Dh750RRl__"